import type { ImageFragment, VideoSectionFragment } from '@/lib/types/datocms/graphql/generated'
import { StructuredText } from 'react-datocms'
import { TextWithHighlight } from '../TextWithHighlight'
import VideoComponent from '../InternalVideoComponent'
import ExternalVideoComponent from './ExternalVideoComponent'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'
import CircleGraphic from '../ui/CircleGraphic'

export default function VideoSection({
	title,
	description,
	video,
}: Readonly<VideoSectionFragment>) {
	return (
		<section className="video-section bg-white-frosted @container">
			<div className="relative common-x-padding max-w-screen-2xl mx-auto py-16 @5xl:py-20 overflow-hidden">
				{title && !isStructuredTextEmpty(title.text) && (
					<div className="heading-size-3 text-center">
						<TextWithHighlight text={title} />
					</div>
				)}
				{description && !isStructuredTextEmpty(description) && (
					<div className="text-center text-lg @5xl:text-2xl text-blue-dark/70 @3xl:4 @5xl:mt-6">
						<StructuredText data={description} />
					</div>
				)}

				{video && (
					<div className="mt-12">
						{video.__typename === 'InternalVideoComponentRecord' ? (
							<VideoComponent {...video} coverImage={video.coverImage as ImageFragment} />
						) : (
							<ExternalVideoComponent {...video} coverImage={video.coverImage as ImageFragment} />
						)}
					</div>
				)}

				<div className="grid grid-cols-2 gap-5 @3xl:gap-8 w-fit absolute top-0 right-0 translate-x-10 @3xl:translate-x-16 -translate-y-20">
					{Array.from({ length: 4 }).map((_, index) => (
						<CircleGraphic key={`shape-${index + 1}`} />
					))}
				</div>
			</div>
		</section>
	)
}
